export const DICTIONARY = '/dictionary';
export const SCHOOLS = '/schools';
export const PROGRAM = '/program/:schoolLevel';
export const SUBJECT = '/subject/:programId';
export const PARTICIPANT = '/participant';
